




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid from '@/components/DataGrid.vue'
import {executeQuery} from '@/data/repos/query'

@Component({
  components: {
    DataGrid,
  },
})

export default class ComplianceElementsWithNoLocationDrillDown extends Vue {
  @Prop() public args!: {
    locationId: string
  }
  public fields = [
    {name: 'ElementDescription', title: 'Element description', dataType: 'Text', sort: 1},
    {name: 'responsiblePerson', title: 'Default responsible person', dataType: 'Text', sort: 1},
    {name: 'manager', title: 'Default manager', dataType: 'Text', sort: 1},
  ]

  public getData(offset = 0, limit = 250) {
    const locationId = parseInt(this.args.locationId)
    return executeQuery("idr", "compliance.elementsWithNoLocationsDrillDown",
      {locationId},
      undefined,
      offset, limit)
  }
}
